import { Controller } from "../vendor/stimulus.js";
import SplideModule from "../vendor/splide.min.js";

export default class extends Controller {

  static targets = [
    "slider"
  ];

  connect() {
    if (!this.hasSliderTarget) return;

    const Splide = SplideModule?.default || SplideModule || window.Splide;
    if (!Splide) return;

    this.splide = new Splide(this.sliderTarget, {
      type: "loop",
      perPage: 1,
      gap: "12px",
      pagination: true,
      arrows: true,
      speed: 600,
      rewind: true,
      autoplay: false
    });

    this.splide.mount();
    this.scheduleRefresh();
    this.element.classList.add("is-ready");
  }

  disconnect() {
    if (this.refreshTimeoutId) {
      clearTimeout(this.refreshTimeoutId);
      this.refreshTimeoutId = null;
    }

    if (this.splide) {
      this.splide.destroy(true);
      this.splide = null;
    }
  }

  scheduleRefresh() {
    const refresh = () => {
      if (this.splide) {
        this.splide.refresh();
      }
    };
    requestAnimationFrame(refresh);
    this.refreshTimeoutId = window.setTimeout(refresh, 200);
  }
}
